import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useLazyForgotPasswordQuery } from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useForgotPasswordApi = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [forgotPassword] = useLazyForgotPasswordQuery();

  const send = (data) => {
    dispatch(setLoader(true));
    forgotPassword(data)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.label + " " + data?.email, "success");
        navigate("/verify-email", {
          state: {
            email: data?.email,
            verify_token: res?.verify_token,
          },
        });
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message, "error");
      });
  };

  return {
    send
  }
};

export default useForgotPasswordApi;
